import React from 'react'
import {Context} from '../Context'

import './ListInput.css'

const ListInput = (props) =>
  <Context.Consumer>
    {
      ({context, actions}) =>
        <div className="list-input">
          <input type="text" placeholder="Enter to-do & press enter" onKeyPress={(e) => {
            if (e.key === 'Enter') {
              if (e.target.value) {
                actions.addItem(e.target.value, props.date, props.items)
                e.target.value = ""
              }
            }
            }} />
       </div>
    }
  </Context.Consumer>

export default ListInput



// WEBPACK FOOTER //
// ./src/components/ListInput.js